/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type HpRespHeroModuleOld_homepage$ref = any;
export type HpRespHeroModuleOld_homepage = {
    readonly heroModuleOld: ({
        readonly title?: string | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
            readonly title: string | null;
            readonly contemporaryTrackingString: string | null;
        } | null> | null;
    } & ({
        readonly title: string | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
            readonly title: string | null;
            readonly contemporaryTrackingString: string | null;
        } | null> | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })) | null;
    readonly " $refType": HpRespHeroModuleOld_homepage$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "HpRespHeroModuleOld_homepage",
        "type": "Homepage",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "heroModuleOld",
                "name": "module",
                "storageKey": "module(type:\"hero\")",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "hero"
                    }
                ],
                "concreteType": null,
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "type": "HeroModule",
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "items",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Product",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "cmsId",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "link",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "imageUrl",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v0 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "contemporaryTrackingString",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'c8fda0ed8436a7094664b9f328c72e1d';
export default node;
